// Shared close triggers for the header widgets (menus, language switcher).
export function onEscape(handler) {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') handler();
  });
}

export function onClickOutside(root, handler) {
  document.addEventListener('click', (event) => {
    if (!root.contains(event.target)) handler();
  });
}
